<template lang="pug">
  div
    .row
      .form-group.col-md-6
        label(for="exchange__exchange_date") 名刺交換日
          span.bcard-required (*)
        date-picker.form-control#exchange__exchange_date(name="exchange[exchange_date]", v-model="exchange.exchange_date", :required="true", maxdate="0", :defaultDate="exchange.formatted_exdate || 'today'" data-testid="-exchange-date")

      .col-md-6
        .form-group
          label 名刺交換者
          p.form-control-static(data-testid="-exchanger-full-name") {{$store.getState('login_user').full_name}}
        .form-group(v-if="isExchangersEditable")
          sel-users(
            v-model="exchange.exchangers",
            input-name="exchange[users][]",
            :view_mode="false"
          )

          div.help-block
            p.bcard-comments.text-info
              | ※ 同じ名刺を交換したユーザーがいる場合、[ユーザー選択]ボタンからほかの名刺交換者を追加してください。
              br
              | 選択したユーザーに同じ名刺が登録されます。
            p.bcard-comments.text-info
              | ※ 「お知らせ」により名刺が登録されたことが通知されます。

    //p.lead
    p(v-if="useAccordion")
      a(href="#jbcard-collapse-exchange" data-toggle="collapse" aria-expanded="false" aria-controls="jbcard-collapse-exchange" data-testid="link-other-exchange") その他の交換時情報
        |
        |
        i.fa.fa-caret-down
        i.fa.fa-caret-up

    #jbcard-collapse-exchange(:class="{collapse: useAccordion}")
      .form-group
        label(for="exchange__ex_location") 交換場所
        .row
          .col-md-6
            template
              select.form-control#exchange__ex_location(name="exchange[ex_location]" v-model="exchange.ex_location" data-testid="-select-exlocation")
                option(v-for="exlocation in exlocations", :value="exlocation.id ? exlocation.name : ''" :data-testid="exlocation.name") {{exlocation.name}}

          .col-md-6
            input.form-control(type="text", name="exchange[ex_location_detail]", v-model="exchange.ex_location_detail", :maxlength="maxlengths.ex_location_detail" data-testid="-exlocation-detail")

      .form-group
        label(for="exchange__ex_trigger") きっかけ
        .row
          .col-md-6
            template
              select.form-control#exchange__ex_trigger(name="exchange[ex_trigger]" v-model="exchange.ex_trigger" data-testid="-select-extrigger")
                option(v-for="extrigger in extriggers", :value="extrigger.id ? extrigger.name : ''" :data-testid="extrigger.name") {{extrigger.name}}

          .col-md-6
            input.form-control(type="text", name="exchange[ex_trigger_detail]", v-model="exchange.ex_trigger_detail", :maxlength="maxlengths.ex_trigger_detail" data-testid="-extrigger-detail")

      .row
        .form-group.col-md-6
          label 社内紹介者
          .form-control-static
            sel-users(
              v-model="exchange.inner_introducer",
              input-name="exchange[in_introducer]",
              :view_mode="false",
              :max-select="1"
            )

        .form-group.col-md-6
          label 社外紹介者
          .form-control-static
            sel-persons(
              v-model="exchange.outer_introducer",
              input-name="exchange[out_introducer]",
              :view_mode="false",
              :max-select="1"
            )
            div.help-block
              p.bcard-comments.text-info
                | ※ 名刺人物として登録されていない社外紹介者については、補足に記入してください。

      .form-group
        label(for="exchange__comment") 補足
        input.form-control#exchange__comment(type="text", name="exchange[comment]", v-model="exchange.comment", :maxlength="maxlengths.comment" data-testid="-comment")

      hr

      .row
        .form-group.col-md-6
          label(for="exchange__age") 年代
          select.form-control#exchange__age(name="exchange[age]" v-model="exchange.age" data-testid="-select-age")
            option(value="") {{app_lang.NO_SELECT}}
            option(value="10" data-testid="-age-10") 10 代
            option(value="20" data-testid="-age-20") 20 代
            option(value="30") 30 代
            option(value="40") 40 代
            option(value="50") 50 代
            option(value="60") 60 代
            option(value="70") 70 代 以上

      .form-group
        label(for="exchange__feature") その他（特徴など）
        input.form-control#exchange__feature(type="text", name="exchange[feature]", v-model="exchange.feature", :maxlength="maxlengths.feature" data-testid="-feature")

      hr

      .form-group
        p.bcard-required ※ (*)は必須項目です。
</template>

<script>
import DatePicker from '@/components/molecules/DatePicker'
import SelUsers from '@/components/organisms/SelUsers'
import SelPersons from '@/components/organisms/SelPersons'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ExtriggerRepository = RepositoryFactory.get('extrigger')
const ExlocationRepository = RepositoryFactory.get('exlocation')

export default {
  name: 'ExchangeForm',
  components: {
    DatePicker,
    SelUsers,
    SelPersons
  },
  props: {
    /**
     * @type Object value exchange
     */
    value: { type: Object, required: true },
    isExchangersEditable: { type: Boolean, required: false, default: false },
    useAccordion: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      exchange: {
        exchange_date: '',
        exchangers: [],
        ex_location: '',
        ex_location_detail: '',
        ex_trigger: '',
        ex_trigger_detail: '',
        inner_introducer: [],
        outer_introducer: [],
        comment: '',
        age: '',
        feature: ''
      },

      // 選択肢一覧
      extriggers: [],
      exlocations: [],

      maxlengths: {}
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncData(newval)
      }
    },
    exchange (exchange) {
      this.$emit('input', exchange)
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Exchanges')
    this.syncData(this.value)

    const vm = this

    // 選択肢取得
    ExtriggerRepository.getChoices()
      .then(function (response) {
        let data = vm.getApiData(response)
        vm.extriggers = data.data
        vm.extriggers.splice(0, 0, {
          'sid_corporate': vm.$store.getState('login_user').sid_corporate,
          'id': '',
          'name': vm.app_lang.NO_SELECT
        })
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })

    ExlocationRepository.getChoices()
      .then(function (response) {
        let data = vm.getApiData(response)
        vm.exlocations = data.data
        vm.exlocations.splice(0, 0, {
          'sid_corporate': vm.$store.getState('login_user').sid_corporate,
          'id': '',
          'name': vm.app_lang.NO_SELECT
        })
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  methods: {
    syncData (data) {
      this.exchange = data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/ExchangeForm.vue